import { isAgentPlatformLocalEnabled } from './featureFlag';

const normalizeConfiguredOrigin = (value: string): string => value.trim().replace(/\/$/, '');
const isLoopbackHost = (hostname: string): boolean => ['localhost', '127.0.0.1'].includes(hostname.toLowerCase());

export const isLocalAgentPlatformOrigin = (api: URL, browser: URL): boolean =>
  browser.protocol === 'http:' && isLoopbackHost(browser.hostname) && browser.port === '3000'
  && api.protocol === 'http:' && isLoopbackHost(api.hostname) && api.port === '8001'
  && !api.username && !api.password && api.pathname === '/' && !api.search && !api.hash;

/** Accept only app.example.test -> agents-api.example.test over HTTPS. */
export const resolveAgentPlatformApiOrigin = (
  configuredApiOrigin = process.env.REACT_APP_AGENT_PLATFORM_API_ORIGIN,
  browserOrigin = typeof window !== 'undefined' ? window.location.origin : undefined,
  localEnabled = isAgentPlatformLocalEnabled(),
): string | undefined => {
  if (!configuredApiOrigin || !browserOrigin) return undefined;
  try {
    const api = new URL(configuredApiOrigin);
    const browser = new URL(browserOrigin);
    if (localEnabled && isLocalAgentPlatformOrigin(api, browser)) return api.origin;
    if (api.protocol !== 'https:' || browser.protocol !== 'https:') return undefined;
    if (api.origin !== normalizeConfiguredOrigin(configuredApiOrigin)) return undefined;
    const dashboardLabels = browser.hostname.toLowerCase().split('.');
    if (dashboardLabels[0] !== 'app' || dashboardLabels.length < 3) return undefined;
    if (api.hostname.toLowerCase() !== `agents-api.${dashboardLabels.slice(1).join('.')}`) return undefined;
    return api.origin;
  } catch (_error) {
    return undefined;
  }
};

/** True only when the explicit local gate has resolved an allowed loopback API origin. */
export const isAgentPlatformLocalMode = (): boolean => {
  if (!isAgentPlatformLocalEnabled()) return false;
  const origin = resolveAgentPlatformApiOrigin();
  return Boolean(origin && new URL(origin).protocol === 'http:');
};
